import { createStyles, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { HOME_URL } from '../../../const/routes';
import CommonContainer from '../../common/CommonContainer';
import CommonLink from '../../common/CommonLink';
import CommonLogo from '../../common/CommonLogo';
import PropTypes from 'prop-types';

const styles = createStyles(theme => ({
  logoWrapper: {
    alignSelf: 'center',
    width: '100%',
    maxWidth: theme.breakpoints.values.sm * 0.38,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  logo: {
    width: '100%',
    height: 'auto',
  },
}));

const AboutPage = React.forwardRef((props, ref) => {
  const { classes } = props;
  return (
    <CommonContainer
      ref={ref}
      vAlign="center"
      hAlign="left"
      size="medium"
    >
      <CommonLink
        className={classes.logoWrapper}
        to={HOME_URL}
      >
        <CommonLogo className={classes.logo} />
      </CommonLink>
      
      <Typography
        paragraph
        variant="h5"
      >
        <FormattedMessage
          id="page.about.header"
          defaultMessage="Welcome to dinkassa.se"
        />
      </Typography>
      
      <Typography paragraph>
        <FormattedMessage
          id="page.about.paragraph.1"
          defaultMessage="Dinkassa.se is an online service that can be used by anyone who have {link1} from {link2}. Here you can log in and see online what's going on in your business. The service works for all types of businesses, e.g. restaurants, cafes, hairdressers and all kinds of shops."
          values={{
            link1: <CommonLink to="http://www.eskassa.se/">ES Kassasystem</CommonLink>,
            link2: <CommonLink to="http://www.erpato.se/">Erpato Europe AB</CommonLink>,
          }}
        />
      </Typography>
      
      <Typography paragraph>
        <FormattedMessage
          id="page.about.paragraph.2"
          defaultMessage="Provided that your cash register is connected to the Internet, information is continuously passed on to our server room via a secure, encrypted connection (your firewall does not need to be changed or opened in any way). Using your personal username and password, you can log in and track sales from any Internet-connected computer. If you run several companies or have several separate cash registers, the entire sale can be controlled jointly or separately for each individual cash register. There is no limit to the number of cash registers that can be linked together to give you a complete overview of your business."
        />
      </Typography>
      
      <Typography paragraph>
        <FormattedMessage
          id="page.about.paragraph.3"
          defaultMessage="With the help of dinkassa.se you can both control and manage your cash, no matter where you are. If you wish, you can also log in to your accounting firm. Then your accountant can go in directly and retrieve the information he needs to do e.g. VAT reports and financial statements. When you use dinkassa.se, you automatically get a complete backup of your cash online. You no longer need to be afraid of losing information to your accounting."
        />
      </Typography>
      
      <Typography paragraph>
        <FormattedMessage
          id="page.about.paragraph.4"
          defaultMessage="ES Cash System includes a basic license at dinkassa.se at no extra cost. You can follow the last days sales. For those who want to dig deeper into their business, we provide more advanced features and the opportunity to see history further back in time."
        />
      </Typography>
      
      <Typography paragraph>
        <FormattedMessage
          id="page.about.paragraph.5"
          defaultMessage="Connect yourself to dinkassa.se now. You will get total control of your business and can save both time and money!"
        />
      </Typography>
      
      <Typography paragraph>
        <FormattedMessage
          id="page.about.paragraph.6"
          defaultMessage="Read more at {link} or contact Erpato Europe AB on tel. {phone} or {email}."
          values={{
            link: <CommonLink to="http://www.eskassa.se/">www.eskassa.se</CommonLink>,
            phone: <CommonLink to="tel:08-41050990">08-41050990</CommonLink>,
            email: <CommonLink to="mailto:info@eskassa.se">info@eskassa.se</CommonLink>,
          }}
        />
      </Typography>
    </CommonContainer>
  );
});

AboutPage.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles, { name: 'AboutPage' })(AboutPage);
